interface Options {
    collectArrayData?: boolean
}

export const getValueFromJSON = (jsn: any, key: string, options? : Options): any => {
    if (!key)
    {
        return jsn;
    }
    let parseData = key.split('.');
    let currentKey = parseData[0];
    if (!jsn || !jsn.hasOwnProperty(currentKey))
    {
        return null;
    }

    if (jsn[currentKey] instanceof Array && options?.collectArrayData) {
        parseData.shift();
        return jsn[currentKey].reduce((res: any[], item: any) => res.concat(getValueFromJSON(item, parseData.join('.'), options)), [])
    }

    if (parseData.length === 1)
    {
        return jsn[currentKey];
    }

    parseData.shift();
    return getValueFromJSON(jsn[currentKey], parseData.join('.'), options)
};

export const setValueInJSON = (jsn: any, key: string, value: any) : any => {
    if (!key)
    {
        return;
    }
    let parseData = key.split('.');
    let currentKey = parseData[0];
    let nextKey = parseData[1];
    let isArray = parseInt(nextKey, 10).toString() === nextKey;

    if (!jsn?.hasOwnProperty(currentKey))
    {
        if (isArray)
        {
            jsn[currentKey] = [];
        }
        else
        {
            jsn[currentKey] = {};
        }
    }

    if (parseData.length === 1)
    {
        return jsn[currentKey] = value;
    }

    parseData.shift();
    return setValueInJSON(jsn[currentKey], parseData.join('.'), value)
};

export const deleteKeyInJSON = (jsn, key: any) => {
    if (!key)
        return;

    let parseData = key.split('.');
    let currentKey = parseData[0];
    let nextKey = parseData[1];
    let isArray = parseInt(nextKey, 10) == nextKey && parseInt(nextKey, 10) >= 0;

    if (!jsn.hasOwnProperty(currentKey))
    {
        if (isArray)
        {
            jsn[currentKey] = [];
        }
        else
        {
            jsn[currentKey] = {};
        }
    }

    if (parseData.length === 1)
    {
        return delete jsn[currentKey];
    }

    parseData.shift();
    return deleteKeyInJSON(jsn[currentKey], parseData.join('.'))
};